module.exports = __webpack_public_path__ + "static/media/menuPhone.92acc7cc.svg";